import { Component, effect, inject, model, OnDestroy } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Alert, AlertMode, AlertType } from '../../schemas/alert';
import { AlertService } from '../../utils/services/alert.service';

@Component({
  selector: 'qwiko-alert',
  imports: [CommonModule],
  templateUrl: './alert.component.html',
  styleUrl: './alert.component.scss',
})
export class AlertComponent implements OnDestroy {
  private alertService = inject(AlertService);
  // [x: string]: any;
  alert = model<Alert | null>(null);
  // alertEffect = effect(() => {
  //   console.log('Alert Changed', this.alert());
  // });
  margin = model<Boolean>(false);

  constructor() {
    effect(() => {
      if (
        this.alert() !== null &&
        this.alert()?.mode !== AlertMode.DISMISSIBLE
      ) {
        this.hideAlertAfterDelay();
      }
      if (this.alert() === null && this.alertService.alert() !== null) {
        this.handOver();
      }
    });
  }

  handOver() {
    this.alert.set(this.alertService.alert());
    this.alertService.clearMessages();
  }

  private hideAlertAfterDelay(): void {
    setTimeout(() => {
      this.alert.set(null);
    }, this.alert()?.delay || 5000);
  }

  closeAlert() {
    this.alert.set(null);
  }

  ngOnDestroy(): void {
    this.alert.set(null);
  }
}
